module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signature",
    class: {
      'state-preview': this.theState === 'preview', 'state-editor': this.theState === 'editor'
    }
  }, [(this.theState === 'editor' && !_vm.payload.signatory) ? _c('div', [_c('strong', [_vm._v("Who would you like to sign this area?")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.signatories,
      "placeholder": "Leave This Space Empty",
      "track-by": "id",
      "label": "name",
      "searchable": false,
      "showLabels": false
    },
    model: {
      value: (_vm.selectedSignatory),
      callback: function($$v) {
        _vm.selectedSignatory = $$v
      },
      expression: "selectedSignatory"
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.waitForContact()
      }
    }
  }, [_c('span', [_c('span', [_vm._v("+")]), _vm._v(" " + _vm._s(_vm.$t('navigation.new_contact')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.payload.signatory) ? _c('div', [(this.theState === 'editor') ? _c('div', [_c('ul', {
    staticClass: "metadata"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Name:")]), _vm._v(" " + _vm._s(_vm.payload.signatory.name))]), _vm._v(" "), _vm._l((_vm.payload.metadata), function(metadata) {
    return _c('li', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (metadata.value),
        expression: "metadata.value"
      }],
      staticClass: "metadata-input",
      attrs: {
        "type": "text",
        "placeholder": "Add title here..."
      },
      domProps: {
        "value": (metadata.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(metadata, "value", $event.target.value)
        }
      }
    })])
  }), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), (this.theState !== 'preview' && this.theState !== 'view') ? _c('button', {
    staticClass: "button is-primary is-outlined is-small",
    on: {
      "click": function($event) {
        _vm.payload.signatory = false
      }
    }
  }, [_vm._v("Change Signatory")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.theState === 'preview') ? _c('div', [_c('ul', {
    staticClass: "metadata"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Name:")]), _vm._v(" " + _vm._s(_vm.payload.signatory.name))]), _vm._v(" "), _vm._l((_vm.payload.metadata), function(metadata) {
    return _c('li', [(metadata.label === 'Title' && metadata.value === '') ? _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" N/A")]) : _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" " + _vm._s(metadata.value))])])
  }), _vm._v(" "), _vm._m(5)], 2)]) : _vm._e(), _vm._v(" "), (this.theState === 'view') ? _c('div', [_c('ul', {
    staticClass: "metadata"
  }, [_vm._m(6), _vm._v(" "), (_vm.isSignable) ? _c('li', [_c('i', {
    staticClass: "status sign-now"
  }, [_vm._v("Sign Now")])]) : _vm._e(), _vm._v(" "), (!_vm.isSignable) ? _c('li', [_c('i', {
    staticClass: "status pending"
  }, [_vm._v("Pending")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Name:")]), _vm._v(" " + _vm._s(_vm.payload.signatory.name))]), _vm._v(" "), _vm._l((_vm.payload.metadata), function(metadata) {
    return _c('li', [(metadata.label === 'Title' && metadata.value === '') ? _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" N/A")]) : _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" " + _vm._s(metadata.value))])])
  }), _vm._v(" "), _vm._m(7)], 2), _vm._v(" "), (_vm.isSignable) ? _c('button', {
    staticClass: "button is-primary is-outlined is-small",
    on: {
      "click": function($event) {
        _vm.changeState('sign')
      }
    }
  }, [_vm._v("Click Here to Sign")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.theState === 'sign') ? _c('div', [_c('ul', {
    staticClass: "metadata"
  }, [_vm._m(8), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autograph),
      expression: "autograph"
    }],
    staticClass: "signature",
    attrs: {
      "type": "text",
      "placeholder": "Sign here..."
    },
    domProps: {
      "value": (_vm.autograph)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submitSignature($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autograph = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Name:")]), _vm._v(" " + _vm._s(_vm.payload.signatory.name))]), _vm._v(" "), _vm._l((_vm.payload.metadata), function(metadata) {
    return _c('li', [(metadata.label === 'Title' && metadata.value === '') ? _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" N/A")]) : _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" " + _vm._s(metadata.value))])])
  }), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(new Date(), "dddd, MMMM Do YYYY")))])], 2), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-small",
    on: {
      "click": _vm.submitSignature
    }
  }, [_vm._v("Complete signature")])]) : _vm._e(), _vm._v(" "), (this.theState === 'signed') ? _c('div', [_c('ul', {
    staticClass: "metadata"
  }, [_vm._m(9), _vm._v(" "), _c('li', {
    staticClass: "signed"
  }, [_vm._v(_vm._s(this.theSignature.signature))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Name:")]), _vm._v(" " + _vm._s(_vm.payload.signatory.name))]), _vm._v(" "), _vm._l((_vm.payload.metadata), function(metadata) {
    return _c('li', [(metadata.label === 'Title' && metadata.value === '') ? _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" N/A")]) : _c('span', [_c('strong', [_vm._v(_vm._s(metadata.label) + ":")]), _vm._v(" " + _vm._s(metadata.value))])])
  }), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(this.theSignature.created_at, "dddd, MMMM Do YYYY")))])], 2)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Signature:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "status not-available"
  }, [_vm._v("Not available in editing mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Date:")]), _vm._v(" "), _c('i', [_vm._v("Set upon signing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Signature:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "status not-available"
  }, [_vm._v("Not available in preview mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Date:")]), _vm._v(" "), _c('i', [_vm._v("Set upon signing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Signature:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Date:")]), _vm._v(" "), _c('i', [_vm._v("Set upon signing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Signature:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Signature:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-678e2dae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/signature.vue
// module id = 531
// module chunks = 0